export const ANALYST_NOTES_KEY = 'analyst_notes';
export const USER_KEY = 'user';
export const MONITORING_KEY = 'monitoring';
export const AUTH = 'authentication';
export const ENTITY_IDS_KEY = 'entity_ids';
export const CALCULATORS_KEY = 'calculators';
export const RISKS_KEY = 'risks';
export const RATINGS_KEY = 'ratings';
export const DOCUMENTATION_KEY = 'documentation';
export const DOCS_KEY = 'docs';
export const MARKET_PRICES_KEY = 'market_prices';
export const STABLECOIN_KEY = 'stablecoin';
export const ALERTING_KEY = 'alerting';
